import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from "parse";
import Api from "../../Utils/api";
import Utils from "../../Utils/Utility";
import OrderMarkConfig from './order-mark-config';
import AutoAccept from './auto-accept';
import OrderNotifications from './order-notifications';
import AnnouncementNotification from './announcement-notification';
import OnlineOrdering from './online-ordering';
import DeliveryConfig from './delivery-config';
import GiftCardConfig from './giftcard-config';
import LocationConfig from './location-config';

export default class LocationDetail extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            isLoaded: true,
            activeLocation: "",
            isOnlineOrderingView: false,
            isOrderMarkConfigView: false,
            isAutoAcceptConfigView: false,
            isOrderNotificationView: false,
            isAnnouncementNotification: false,
            isLocationConfigView: false,
            isDeliverySettingView: false,
            isDeliveryInfoUpdated: false,
            isGiftCardsSettingView: false,
        }

        this._bind(
            'getLocationDetailWithPvtConfig',
            'enableOnlineOrderingView',
            'enableOrderMarkConfigView',
            'enableAutoAcceptConfigView',
            'enableOrderNotificationView',
            'enableAnnouncementNotification',
            'enableLocationConfigView',
            'enableDeliverySetting',
            'showLoadingSpinner',
            'enableDeliverySetting',
            'enableGiftCardsSetting'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {

        this.getLocationDetailWithPvtConfig();
        this.enableOnlineOrderingView();

    }

    componentWillMount() {

        this.setState({
            activeLocation: this.props.activeLocation
        });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null) {
            this.setState({
                    activeLocation: nextProps.activeLocation
                },
                () => {
                    this.getLocationDetailWithPvtConfig();
                });
        }
    }


    enableOnlineOrderingView(){
        this.setState({
            isOnlineOrderingView: true,
            isOrderMarkConfigView: false,
            isAutoAcceptConfigView: false,
            isOrderNotificationView: false,
            isAnnouncementNotification: false,
            isLocationConfigView: false,
            isDeliverySettingView: false,
            isGiftCardsSettingView: false,

        });
    }

    enableOrderMarkConfigView(){
        this.setState({
            isOnlineOrderingView: false,
            isOrderMarkConfigView: true,
            isAutoAcceptConfigView: false,
            isOrderNotificationView: false,
            isAnnouncementNotification: false,
            isLocationConfigView: false,
            isDeliverySettingView: false,
            isGiftCardsSettingView: false,

        });
    }

    enableAutoAcceptConfigView(){
        this.setState({
            isOnlineOrderingView: false,
            isOrderMarkConfigView: false,
            isAutoAcceptConfigView: true,
            isOrderNotificationView: false,
            isAnnouncementNotification: false,
            isLocationConfigView: false,
            isDeliverySettingView: false,
            isGiftCardsSettingView: false,


        });
    }

    enableOrderNotificationView(){
        this.setState({
            isOnlineOrderingView: false,
            isOrderMarkConfigView: false,
            isAutoAcceptConfigView: false,
            isOrderNotificationView: true,
            isAnnouncementNotification: false,
            isLocationConfigView: false,
            isDeliverySettingView: false,
            isGiftCardsSettingView: false,


        });
    }

    enableAnnouncementNotification(){
        this.setState({
            isOnlineOrderingView: false,
            isOrderMarkConfigView: false,
            isAutoAcceptConfigView: false,
            isOrderNotificationView: false,
            isAnnouncementNotification: true,
            isLocationConfigView: false,
            isDeliverySettingView: false,
            isGiftCardsSettingView: false,

        });
    }

    async enableDeliverySetting(){
        await this.getLocationDetailWithPvtConfig();

        this.setState({
            isOnlineOrderingView: false,
            isOrderMarkConfigView: false,
            isAutoAcceptConfigView: false,
            isOrderNotificationView: false,
            isAnnouncementNotification: false,
            isLocationConfigView: false,
            isDeliverySettingView: true,
            isGiftCardsSettingView: false,
        });
    }

    async enableGiftCardsSetting() {
        await this.getLocationDetailWithPvtConfig();

        this.setState({
            isOnlineOrderingView: false,
            isOrderMarkConfigView: false,
            isAutoAcceptConfigView: false,
            isOrderNotificationView: false,
            isAnnouncementNotification: false,
            isLocationConfigView: false,
            isDeliverySettingView: false,
            isGiftCardsSettingView: true,
        });
    }


    enableLocationConfigView() {
        this.setState({
            isOnlineOrderingView: false,
            isOrderMarkConfigView: false,
            isAutoAcceptConfigView: false,
            isOrderNotificationView:false,
            isAnnouncementNotification:false,
            isLocationConfigView:true,
            isDeliverySettingView:false,
            isGiftCardsSettingView: false,
        });
    }

    showLoadingSpinner(status){
        this.setState({
            isLoaded: status
        });
    }

    async getLocationDetailWithPvtConfig() {

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();

        let activeLocation = this.props.activeLocation;
        let locId = activeLocation.objectId;

        let self = this;

        self.setState({
            isLoaded : false
        });


      await Api.getLocationDetail(locId, userId, sessionToken)
            .then(
                (result) => {

                    const locationDetail = result.data;

                    self.setState({
                        activeLocation: locationDetail,
                        isLoaded : true,
                        isDeliveryInfoUpdated: true
                    });


                },
                (error) => {
                    if (error != null && error.responseJSON != null && error.responseJSON.error != null) {
                        console.log("Error occured while fetching the location data!" + JSON.stringify(error));
                        this.setState({isLoaded : true });
                        alert(error.responseJSON.error.message);
                    }
                    Utils.checkErrorIsInvalidSessionToken(error,this.context.router);
                });
    }



    render() {

        return (
            <div className="order-pg">
                {!this.state.isLoaded ? <Spinner/> : null}
                {/*{*/}
                    {/*this.state.errors["errors"] ? (*/}
                        {/*<div className="alert alert-danger text-center" role="alert">*/}
                            {/*<span className="form-text">{this.state.errors["errors"]}</span>*/}
                        {/*</div>) : null*/}

                {/*}*/}
                <nav id="sidebar-location" className={"sidebar-nav-location"}>
                <ul className="snip1226">
                    <li className={this.state.isOnlineOrderingView ? "current" : null}><a
                        href= "JavaScript:void(0);"
                        onClick = {this.enableOnlineOrderingView}
                        data-hover="Online Ordering">Online Ordering</a>
                    </li>
                    <li className={this.state.isLocationConfigView ? "current" : null}>
                        <a href= "JavaScript:void(0);"
                           onClick = {this.enableLocationConfigView}
                           data-hover="Location Config">Location Config</a>
                    </li>
                    <li className={this.state.isOrderMarkConfigView ? "current" : null}><a
                        href= "JavaScript:void(0);"
                        onClick = {this.enableOrderMarkConfigView}
                        data-hover="OrderMark">OrderMark/Otter Sync</a></li>
                    <li className={this.state.isAutoAcceptConfigView ? "current" : null}><a
                        href= "JavaScript:void(0);"
                        onClick = {this.enableAutoAcceptConfigView}
                        data-hover="Auto Accept">Auto Accept</a></li>
                    <li className={this.state.isOrderNotificationView ? "current" : null}><a
                        href= "JavaScript:void(0);"
                        onClick = {this.enableOrderNotificationView}
                        data-hover="Order Notifications">Order Notifications</a></li>
                    <li className={this.state.isAnnouncementNotification ? "current" : null}><a
                        href="JavaScript:void(0);"
                        onClick={this.enableAnnouncementNotification}
                        data-hover="Announcement Message">Announcement Message</a></li>
                    <li className={this.state.isDeliverySettingView ? "current" : null}><a
                        href="JavaScript:void(0);"
                        onClick={this.enableDeliverySetting}
                        data-hover="Delivery Config">Delivery Settings</a></li>
                    <li className={this.state.isGiftCardsSettingView ? "current" : null}><a
                        href="JavaScript:void(0);"
                        onClick={this.enableGiftCardsSetting}
                        data-hover="GiftCard Config">Gift Card Settings</a></li>
                </ul>
                </nav>
                {
                    this.state.isOnlineOrderingView ? (
                        <OnlineOrdering
                            activeLocation={this.state.activeLocation}
                            reloadLocation={this.getLocationDetailWithPvtConfig}
                            isLoaded={this.state.isLoaded}
                        />
                    ) : null
                }

                {
                    this.state.isLocationConfigView ? (
                        <LocationConfig
                            activeLocation={this.state.activeLocation}
                            reloadLocation={this.getLocationDetailWithPvtConfig}
                            isLoaded={this.state.isLoaded}
                        />
                    ) : null
                }

                {
                    this.state.isOrderMarkConfigView ? (
                        <OrderMarkConfig
                            activeLocation={this.state.activeLocation}
                            reloadLocation={this.getLocationDetailWithPvtConfig}
                            isLoaded={this.state.isLoaded}
                        />
                    ) : null
                }
                {
                    this.state.isAutoAcceptConfigView ? (
                        <AutoAccept
                            activeLocation={this.state.activeLocation}
                            reloadLocation={this.getLocationDetailWithPvtConfig}
                            isLoaded={this.state.isLoaded}
                        />
                    ) : null
                }{
                    this.state.isOrderNotificationView ? (
                        <OrderNotifications
                            activeLocation={this.state.activeLocation}
                            reloadLocation={this.getLocationDetailWithPvtConfig}
                            isLoaded={this.state.isLoaded}
                        />
                    ) : null
                }{
                    this.state.isAnnouncementNotification? (
                        <AnnouncementNotification
                            activeLocation={this.state.activeLocation}
                            reloadLocation={this.getLocationDetailWithPvtConfig}
                            isLoaded={this.state.isLoaded}
                        />
                    ) : null
                }
                {
                    this.state.isDeliverySettingView ? (
                        <DeliveryConfig
                            activeLocation={this.state.activeLocation}
                            key={this.state.activeLocation}
                            reloadLocation={this.getLocationDetailWithPvtConfig}
                            showSpinner={this.showLoadingSpinner}
                            isLoaded={this.state.isLoaded}
                            isDeliveryInfoUpdated={this.state.isDeliveryInfoUpdated}
                        />
                    ) : null
                }
                {
                    this.state.isGiftCardsSettingView ? (
                        <GiftCardConfig
                            activeLocation={this.state.activeLocation}
                            key={this.state.activeLocation}
                            reloadLocation={this.getLocationDetailWithPvtConfig}
                            showSpinner={this.showLoadingSpinner}
                            isLoaded={this.state.isLoaded}
                            isDeliveryInfoUpdated={this.state.isDeliveryInfoUpdated}
                        />
                    ) : null
                }

            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/location/location-detail.js